import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { StyledIcon } from './icon.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var Icon = function Icon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(SvgIcon, {
    component: "i",
    inheritViewBox: true,
    className: className,
    color: color,
    children: /*#__PURE__*/_jsx(StyledIcon, _objectSpread({
      color: color
    }, props))
  });
};